// Authentication URLs
export const LOGIN = "api/admin/login";
export const PASSWORD_FORGET = "api/admin/forgot-password";
export const RESET_PASSWORD = "api/admin/reset-password";
export const EDIT_USER = "api/admin/update-profile";
export const FETCH_PROFILE = "api/admin/profile";

// User Management URLs
export const GET_ALL_USERS = "api/admin/users";
export const GET_USER_DETAILS = "api/admin/user";
export const BULK_DELETE_USERS = "api/admin/users/bulk-delete";
export const GET_USER_HISTORY = "api/admin/users";
export const UPDATE_USER = "api/users";

// Dashboard
export const dashboardCount = "api/admin/dashboard-summary";
export const dashboardAnalytics = "api/admin/analytics";

// Farmhouse URLs
export const GET_ALL_FARMHOUSES = "api/farmhouse/admin/all";
export const FARMHOUSE = "api/farmhouse";
// Bookings URLs
export const BOOKINGS = "api/bookings";
export const ADMIN_GET_BOOKINGS = "api/bookings/admin/all";
export const ADMIN_BOOKING = "api/bookings/admin";
// Available farms for bookings
export const AVAILABLE_FARMS = "api/bookings/available-farms";
export const FARMHOUSE_BOOKING_HISTORY = "api/bookings/farm";
export const FARM_STATISTICS = "api/bookings/farm";

// Static Pages URLs
export const HOUSE_RULES = "api/static-pages/houseRules";
export const PRIVACY_POLICY = "api/static-pages/privacyPolicy";
export const TERMS_AND_CONDITIONS = "api/static-pages/termsAndCondition";
export const CANCELLATION_POLICY = "api/static-pages/cancellationPolicy";

// Settings URLs
export const SETTINGS = "api/settings";
export const GET_LOGO = "api/settings/logo";
export const GET_DARK_LOGO = "api/settings/logo-dark";
export const GET_LOGIN_IMAGE = "api/settings/login-image";
export const GET_HERO_SLIDERS = "api/settings/hero-sliders";
export const UPLOAD_LOGO = "api/settings/logo";
export const UPLOAD_DARK_LOGO = "api/settings/logo-dark";
export const UPLOAD_LOGIN_DIALOG_IMAGE = "api/settings/login-image";
export const UPLOAD_HERO_SLIDERS = "api/settings/hero-sliders";
export const DELETE_HERO_SLIDER = "api/settings/hero-sliders";

// Locations URLs
export const LOCATIONS = "api/locations";
